export default class TeamMemberBio {
  constructor() {
    $('.bio-toggle').on('click', () => {
      $(event.currentTarget).toggleClass("open");
      $(event.currentTarget).next('.team-member-bio__bio__tray').slideToggle(300);
    });
  }
}
